module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/settings/masterdata/masterdata.html
// module id = 479
// module chunks = 0